import { Component, app, ojs, v } from "modular-openscriptjs";
import { pageInfo, either, uniqueId } from "../../helpers";
import { PAGES, gc, uc, dc } from "../../declarations";
import Link from "../Blocks/Link";
import Logo from "../Blocks/Logo";
import DepositCapaForm from "../Forms/DepositCapaForm";
import TransferCapaForm from "../Forms/TransferCapaForm";
 
import { $e } from "../../ojs.events";

const h = app("h");
const broker = app("broker");

ojs(Link, Logo);

export default class Wallet extends Component {
    render(...args) {
        pageInfo(PAGES.WALLET);
        broker.send($e.capa.needs.balance);

        return h.div(
            {
                class: "pb-5 mb-5 container-xl py-md-5",
            },

            h.div(
                {
                    class: "card card-capa mb-3",
                },
                h.div(
                    { class: "card-body" },
                    h.div(
                        {
                            class: "d-flex align-items-center justify-content-between card-header-row",
                        },
                        h.div(
                            {
                                class: "d-flex align-items-center card-logo-group",
                            },
                            h.Logo({ class: "card-logo" }),
                            h.h6(
                                {
                                    class: "mb-0 fw-600 text-warning card-title-text",
                                },
                                "Capa Wallet",
                            ),
                        ),
                        h.span(
                            { class: "text-orange-400 opacity-75" },
                            h.$svg(
                                { class: "card-icon" },
                                h.$use({ href: "#gms_sim_card" }),
                            ),
                        ),
                    ),
                    h.div(
                        {
                            class: "d-flex justify-content-between card-info-row",
                        },
                        h.div(
                            { class: "d-flex flex-column" },
                            h.span(
                                {
                                    class: "text-uppercase text-white card-label",
                                },
                                "Account Number:",
                            ),
                            h.span(
                                { class: "text-white fw-600 card-text" },
                                v(uc.capa, (capa) => {
                                    return capa?.value?.account_number;
                                }),
                            ),
                        ),
                        h.div(
                            { class: "d-flex flex-column" },
                            h.span(
                                {
                                    class: "text-uppercase text-white card-label",
                                },
                                "Account Owner:",
                            ),
                            h.span(
                                { class: "text-white fw-600 card-text" },
                                v(gc.user, (user) =>
                                    either(
                                        user?.value?.type == "business",
                                        user?.value?.display_name,
                                        user?.value?.first_name,
                                    ),
                                ),
                            ),
                        ),
                    ),
                    h.div(
                        h.div(
                            { class: "d-flex flex-column" },
                            h.span(
                                {
                                    class: "text-uppercase text-white card-label",
                                },
                                "Balance:",
                            ),
                            h.h2(
                                {
                                    class: "mb-0 text-white fw-600 card-balance",
                                },
                                dc.capaSymbol,
                                v(uc.capa, (capa) =>
                                    Intl.NumberFormat().format(
                                        capa?.value?.balance ?? 0,
                                    ),
                                ),
                            ),
                        ),
                    ),
                ),
            ),
            h.div(
                {
                    class: "row g-3 mb-4",
                },
                this.renderActionCard(
                    "Deposit",
                    "Add funds to wallet",
                    "plus-circle",
                    "success",
                    this.method("purchase"),
                ),
                this.renderActionCard(
                    "Withdraw",
                    "Cash out to Mpesa",
                    "cash",
                    "danger",
                    this.method("withdraw"),
                ),
                this.renderActionCard(
                    "Transfer",
                    "Send money to rider",
                    "arrow-left-right",
                    "info",
                    this.method("transfer"),
                ),
                this.renderActionCard(
                    "History",
                    "Transaction history",
                    "clock-history",
                    "primary",
                    h.func("app('router').to", "user.capa-transfers"),
                ),
            ),
            h.div(
                { class: "pt-4 pb-2" },
                h.div(
                    { class: "d-flex align-items-start gap-2 mb-2" },
                    h.$svg(
                        { width: 22, height: 22, class: "text-blue" },
                        h.$use({ href: "#gms_info" }),
                    ),
                    h.h6(
                        { class: "mb-0 py-1 fw-600" },
                        "What can I do with Capa?",
                    ),
                ),
                h.ul(
                    h.li("Cash out to Mpesa Instantly"),
                    h.li("Pay for Orders in the customer App."),
                    h.li("Transfer Capa to your fellow deliverers."),
                ),
                h.div(
                    { class: "d-flex align-items-start gap-2 mb-2" },
                    h.$svg(
                        { width: 22, height: 22, class: "text-blue" },
                        h.$use({ href: "#gms_info" }),
                    ),
                    h.h6({ class: "mb-0 py-1 fw-600" }, "How do I earn Capa?"),
                ),
                h.ul(
                    h.li("Direct purchase"),
                    h.li("Get rewarded for excellent performance"),
                ),
            ),
            ...args,
        );
    }

    purchase() {
        broker.send($e.capa.needs.deposit);
    }

    withdraw() {
        broker.send($e.capa.needs.withdraw);
    }

    transfer() {
        broker.send($e.capa.needs.transfer);
    }

    renderActionCard(
        title,
        description,
        icon,
        color,
        onclick,
        colClass = "col-6 col-md-3",
    ) {
        return h.div(
            { class: colClass },
            this.renderActionCardInner(title, description, icon, color, onclick)
        );
    }

    renderActionCardInner(
        title,
        description,
        icon,
        color,
        onclick,
    ) {
        const isCustomColor = color === "morning";
        const rgbVar = isCustomColor
            ? "var(--ca-morning-rgb)"
            : `var(--bs-${color}-rgb)`;
        const iconColor = isCustomColor ? "#d9a406" : `var(--bs-${color})`;

        return h.div(
            {
                class: "card border-0 rounded-4 cursor-pointer hover-shadow transition-all h-100",
                style: `background-color: rgba(${rgbVar}, 0.15); color: black;`,
                onclick: onclick,
                role: "button",
            },
            h.div(
                {
                    class: "card-body p-3 text-center d-flex flex-column align-items-center justify-content-center",
                },
                h.div(
                    {
                        class: "bg-white rounded-circle circle d-inline-flex p-3 mb-2 shadow-sm",
                        style: `color: ${iconColor}; width: 52px; height: 52px; align-items: center; justify-content: center;`,
                    },
                    h.i({ class: `bi bi-${icon} fs-3` }),
                ),
                h.h5({ class: "fw-bold mb-1 fs-6 text-dark" }, title),
                h.p(
                    {
                        class: "small mb-0 opacity-75 fw-500",
                        style: "font-size: 0.75rem;",
                    },
                    description,
                ),
            ),
        );
    }
}
